module.exports = __webpack_public_path__ + "static/img/肿瘤.992c5c21.jpg";